import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './icon.less'

import AddPhoto from '!!babel-loader!react-svg-loader!images/addphoto.svg' // eslint-disable-line import/no-unresolved
import Party from '!!babel-loader!react-svg-loader!images/party.svg' // eslint-disable-line import/no-unresolved
import Gift from '!!babel-loader!react-svg-loader!images/gift.svg' // eslint-disable-line import/no-unresolved
import Rocket from '!!babel-loader!react-svg-loader!images/rocket.svg' // eslint-disable-line import/no-unresolved
import Shop from '!!babel-loader!react-svg-loader!images/shop.svg' // eslint-disable-line import/no-unresolved
import MoneyOut from '!!babel-loader!react-svg-loader!images/money_out.svg' // eslint-disable-line import/no-unresolved
import Profile from '!!babel-loader!react-svg-loader!images/no_avatar.svg' // eslint-disable-line import/no-unresolved
import Bank from '!!babel-loader!react-svg-loader!images/bank.svg' // eslint-disable-line import/no-unresolved
import People from '!!babel-loader!react-svg-loader!images/pools_logo.svg' // eslint-disable-line import/no-unresolved
import PayPalIcon from '!!babel-loader!react-svg-loader!images/PP_icon.svg' // eslint-disable-line import/no-unresolved

export const ICON_SIZES = {
  normal: '35%',
  big: '45%',
  huge: '75%',
}

export const STROKE_COLORS = ['black', 'blue', 'white']

class Icon extends React.Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
    iconSize: PropTypes.oneOf(Object.keys(ICON_SIZES)),
    strokeColor: PropTypes.oneOf(STROKE_COLORS),
  }

  static defaultProps = {
    iconSize: 'normal',
    strokeColor: 'black',
  }

  render() {
    let IconSVG
    let disableFill // some icons are buggy when using the `fill` css option
    switch (this.props.type) {
      case 'add-photo':
        IconSVG = AddPhoto
        break
      case 'party':
        IconSVG = Party
        break
      case 'gift':
        IconSVG = Gift
        break
      case 'rocket':
        IconSVG = Rocket
        break
      case 'shop':
        IconSVG = Shop
        break
      case 'money-out':
        IconSVG = MoneyOut
        break
      case 'profile':
        IconSVG = Profile
        disableFill = true
        break
      case 'bank':
        IconSVG = Bank
        disableFill = true
        break
      case 'people':
        IconSVG = People
        disableFill = true
        break
      case 'paypal-icon':
        IconSVG = PayPalIcon
        disableFill = true
        break
      default:
        IconSVG = ''
    }

    const styleName = `icon stroke-color-${this.props.strokeColor} ${
      disableFill ? 'disable-fill' : ''
    }`

    return (
      <IconSVG
        styleName={styleName}
        width={ICON_SIZES[this.props.iconSize]}
        height={ICON_SIZES[this.props.iconSize]}
      />
    )
  }
}

export default cssModules(Icon, styles, { allowMultiple: true })
